import apiClient from '../apiClient';
import { GET_ACCOMODATION_ITEM_TYPES_URL } from '../apiUrl';

const getAccomodationItemTypesApi = () => {
  return apiClient.get(GET_ACCOMODATION_ITEM_TYPES_URL);
};

export default getAccomodationItemTypesApi;
